import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, QueryDropdown, BasicQueryInput } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';

function InventoryListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        facilityStore,
        pumpStore,
        authorization,
        downloadUrl,
        corporateStore,
        searchStore
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore}>
            <PageNavigation>
                {downloadUrl ? <a className="btn btn--base btn--ghost" href={downloadUrl}><i className="u-icon u-icon--sml u-icon--download-btn"></i>Download</a> : null}
            </PageNavigation>
            <Content  emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <BasicQueryInput queryUtility={queryUtility} type="search" store={searchStore} propertyName="search" label='Serial Number' />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={pumpStore} propertyName="productId" label="Product" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={corporateStore} propertyName="corporateId" label="Corporate" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='INVENTORY.LIST.EMPTY_STATE.TITLE' description='INVENTORY.LIST.EMPTY_STATE.DESCRIPTION' />
}

InventoryListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(InventoryListTemplate);
